var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"height":"161px","width":"210px","top":"-85px","position":"absolute"},attrs:{"src":_vm.imageSrc,"spinner-color":"primary"}})}
var staticRenderFns = []

export { render, staticRenderFns }